/**
 * SVG PostgreSQL icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    circleStyle: PropTypes.string.isRequired,
    elephantStyle: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledPostgreSQLIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { circleStyle, elephantStyle } = classes;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <g>
        <circle className={circleStyle} cx="60" cy="60" r="55.5" />
        <g>
          <path
            className={elephantStyle}
            d="M75.9,104.2c-1.1-0.2-4.5-1.1-5.4-1.6c-0.8-0.3-0.7-0.4-1.3-0.8c-1.1-1.4-3.8-3.6-4-5.3c-0.2-2.1-0.1-0.1-0.2-2.2
            c-0.1-2.9-0.2-5.8-0.1-8.7c0-1.3,0-2.6,0.1-3.8c0-2.5-5-6.5-7.5-6.9c-0.3,0-0.5,0-0.8-0.1c-0.6-0.1-0.4-0.1-0.3-0.4
            c0.3-1.1,0.7-2.2,1.1-3.3c0.6-1.5,1.3-2.9,1.9-4.5c0.6-1.7,1-3.4,1.1-5.2c0.3-3.6-0.2-7.1-1-10.6c-0.4-1.8-1.3-3.2-3-4.1
            c-1.2-0.6-2.4-0.8-3.7-0.8c-2.5,0-4.8,0.9-7.1,2c-0.1,0.1-0.3,0.3-0.5,0.2c-0.2-0.1-0.1-0.4-0.1-0.5c0.2-2,0.5-3.9,1-5.8
            c0.6-2.3,1.5-4.5,2.8-6.5c2.5-3.9,6-6.3,10.7-6.8c6.6-0.7,12.6,1,17.7,5.3c3.7,3,6.3,6.8,8.1,11.2c0.3,0.7,0.3,0.7-0.4,0.7
            c-1.6-0.1-3.1-0.1-4.6,0.3c-2,0.5-3.7,1.5-4.6,3.5c-0.5,1.1-0.7,2.3-0.6,3.6c0.2,3.7,1.7,7.1,3.3,10.4c0.8,1.7,1.7,3.3,2.6,4.9
            c0.5,0.9,0.8,1.8,1.3,2.7c0.6,1.2,0.2,0.8,0.2,2.6c0.2,0.9,0.5,0.2-0.4,1.4c-1.2,1.5-3.5,0.9-4.6,2.6c-1.7,2.6-1.6,3.3-1.9,5.8
            c-0.3,2.2-0.4,8-0.7,10.2c-0.3,2.1,7.5,9.1,4.6,10c-1,0.3-2,0.5-3.1,0.7C75.9,104.2,76.7,104.2,75.9,104.2z"
          />
          <path
            className={elephantStyle}
            d="M17.2,42.6c0.1-0.8,0.2-1.7,0.4-2.5c0.5-2.6,1.6-5,3.6-7.1c2.1-2.2,5-3.5,8.4-4.2c3.2-0.7,6.6-0.8,9.9-0.6
            c4.2,0.2,8.2,1.6,12.2,2.6c0.3,0.1,0.6,0.2,0.2,0.5c-3.1,2.5-5.2,4.8-6.6,8.1c-1,2.3-1.6,4.7-2,7.2c-0.2,1.6-0.4,3.2-0.3,4.8
            c0.1,1.4,0.2,2.8,0.2,4.2c0,2.3-0.2,4.6-0.5,6.9c-0.6,3.8,0.8,6.4,3.9,9.3c0.4,0.4,1.9,1.3,2.5,1.6c0.3,0.2,0.3,0.3,0,0.6
            c-2.9,2.4-6.9,5.2-9.6,7.7c-0.6,0.6-1.3,1.1-2.2,1.4c-1.1,0.4-2.1,0.4-3.2,0c-1.2-0.5-2.1-1.2-2.9-2c-1.9-1.9-3.3-4.1-4.6-6.3
            c-2.9-5.2-4.9-10.7-6.7-16.2c-1-3.1-1.8-6.3-2.5-9.5c-0.2-0.8-0.3-1.7-0.4-2.5C17.2,45.4,17.2,44,17.2,42.6z"
          />
          <path
            className={elephantStyle}
            d="M99.9,41.6c-0.1,0.6-0.2,1.2-0.3,1.9c-0.4,2.9-1.2,5.7-2.2,8.5c-2.6,7.1-7,13.7-11.8,19.9c-0.1,0.1-0.1,0.4-0.5,0.3
            c-0.3-0.1-0.4-0.5-0.3-0.7c0.8-1.1,1.6-2.3,2-3.6c0.5-1.7,1-3.4,0.9-5.1c-0.2-2.5-0.8-4.9-0.7-7.4c0.1-1.5,0.4-3,0.7-4.5
            c0.3-1.6,0.4-3.1,0.3-4.7C88,45,87.4,44,86.9,43c-2.1-3.9-5-6.8-8.8-9.8c-2.6-1.9-6.2-3.8-9.5-4.4c-0.2,0-0.4,0-0.6-0.2
            c0.5-0.2,2.1-1.1,2.6-1.2c1.2-0.2,2.3-0.3,3.5-0.3c0.1,0,0.2,0,0.2-0.1c1.8,0,3.6,0,5.4,0c0.9,0.1,1.8,0.2,2.7,0.3
            c5.8,0.7,10.8,2.8,14.8,6.3c1.1,1,2.1,1.9,2.4,3.3c0.1,0.5,0.2,1,0.3,1.5C99.9,39.5,99.9,40.5,99.9,41.6z"
          />
          <path
            className={elephantStyle}
            d="M61.4,59.7c0-3-0.5-5.6-1.1-8.2c-0.5-2.2-2.6-5.7-4.9-5.8c-1.5,0-4.4,0.2-5.8,0.7c-1.2,0.4-3.4,0.4-4.4,1.2
            c-0.2,0.1-0.2,3.6-0.2,3.9c0.1,0.5,0,1,0.1,1.5c0.2,2.1,0.1,4.1,0.1,6.2c0,0.7-0.1,1.5-0.2,2.2c-0.1,1.3-0.3,2.5-0.2,3.8
            c0.3,2.9,1.6,5.4,3.9,7.2c1.4,1.1,3.1,1.7,4.9,1.8c0.3,0,2.8,0.8,2.9,0.5c0.5-2,1.7-4.2,2.5-6.1C60.3,65.9,61.5,62.4,61.4,59.7z
            M57,53.5c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C58.3,53,57.7,53.5,57,53.5z"
          />
          <path
            className={elephantStyle}
            d="M85.3,56.7c-0.1-1.5,0.1-2.9,0.3-4.3c0.2-1.2,0.4-2.3,0.4-3.5c0-0.6-0.1-5.4-1.3-3.9c-2-0.3-1.4,0.3-2.5,0.4
            c-0.5,0-2.6,0.2-3.1,0.3c-2,0.6-4.6,2.6-4.7,4.8c0,2.1,0.3,5.9,1,7.8c1.5,4,4.6,8.1,6.4,11.9c0,0.1-1.1,4,0.4,4.6
            c0.1,0,2.2-2.5,3-5.1c0.2-0.5,0.2-1.3,0.3-1.9c0.6-2.2,0.4-4.5,0.1-6.7C85.5,59.7,85.3,58.2,85.3,56.7z M77.4,53.7
            c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C78.7,53.1,78.1,53.7,77.4,53.7z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

UnstyledPostgreSQLIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  elephantStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.teal,
    stroke: theme.customColors.teal,
  },
});

export default withStyles(styles)(UnstyledPostgreSQLIcon);
